import { CommonModule, DatePipe, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { PersonalAccount } from '../../../../models/repEditorModels'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-personal-accounts',
    templateUrl: './rep-editor-personal-accounts.component.html',
    styleUrls: ['./rep-editor-personal-accounts.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        DatePickerComponent,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
        AdminOnlyDirective
    ]
})
export class RepEditorPersonalAccountsComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  personalAccounts: PersonalAccount[]
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repPersonalAccounts) {
      this.initGrid()
    }
  }

  initGrid() {
    this.clientService
      .getPersonalAccountsForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repPersonalAccounts = response.map(
          (pa) => new PersonalAccount(pa),
        )
      })
  }

  public addHandler({ sender }) {
    const newPersonalAccount = new PersonalAccount(null)
    newPersonalAccount.repId = this.repId
    newPersonalAccount.active = true
    this.addHandlerShared({ sender }, newPersonalAccount)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const personalAccount = new PersonalAccount(formGroup.value)
    this.clientService
      .submitPersonalAccountUpdate(personalAccount)
      .subscribe(() => {
        sender.closeRow(rowIndex)
        this.initGrid()
      })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new PersonalAccount(dataItem)
    itemToRemove.active = false
    this.clientService
      .submitPersonalAccountUpdate(itemToRemove)
      .subscribe(() => {
        this.initGrid()
      })
  }

  public createFormGroup(personalAccount: PersonalAccount): UntypedFormGroup {
    return this.formBuilder.group({
      outsideAccountId: personalAccount.outsideAccountId,
      repId: personalAccount.repId,
      custodian: [personalAccount.custodian, Validators.required],
      accountNumber: personalAccount.accountNumber,
      accountTitle: personalAccount.accountTitle,
      relationship: personalAccount.relationship,
      startDate: personalAccount.startDate,
      endDate: personalAccount.endDate,
      active: personalAccount.active,
    })
  }
}
